

document.addEventListener('DOMContentLoaded', function() {

     // Función para capitalizar los textos de .grid-product__title
     function capitalizeGridProductTitles() {
        const titles = document.querySelectorAll('.grid-product__title');
        
        if (titles.length > 0) {
            titles.forEach(function(title) {
            //    title.textContent = title.textContent.toUpperCase();
                title.textContent = title.textContent
                    .toLowerCase()
                    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word

               // console.log('title' + title.textContent)
            });
        }
    }

   

    const elemList = document.getElementById('list-view');
    const elemGrid = document.getElementById('grid-view');
    let container = document.getElementById('Huratips-Loop');

    if (elemList != null){
        // your code here.
    elemList.addEventListener('click', function handleClick() {
        container.classList.add('list-view'); 
        elemList.classList.add('disabled');  
        elemGrid.classList.remove('disabled');    
    });
    }



    if (elemList != null){
        elemGrid.addEventListener('click', function handleClick() {
            container.classList.remove('list-view'); 
            elemList.classList.remove('disabled');
            elemGrid.classList.add('disabled');    
        });
}

    // Ejecuta la capitalización al cargar la página
    capitalizeGridProductTitles();
    
    // Aquí puedes agregar más código JavaScript que necesites ejecutar al cargar la página
    
});
// Set products: top availability first, then compatible bottoms.
(function () {
  function initializeSetPickers(root) {
    root.querySelectorAll('.product-section').forEach(section => {
      const top = section.querySelector(
        '.variant-input-wrap[data-handle="top-size"]'
      );
      const bottom = section.querySelector(
        '.variant-input-wrap[data-handle="bottom-size"]'
      );
      const data = section.querySelector('script[data-current-product]');

      if (!top || !bottom || !data || top.dataset.setPickerReady) return;

      let product;
      try {
        product = JSON.parse(data.textContent);
      } catch (error) {
        console.error('Set picker: product data could not be read.', error);
        return;
      }

      if (!Array.isArray(product.variants)) return;
      top.dataset.setPickerReady = 'true';

      const available = product.variants.filter(variant => variant.available);

      function updateGroup(group, allowed) {
        group.querySelectorAll('.variant-input').forEach(wrapper => {
          const input = wrapper.querySelector('input');
          const label = wrapper.querySelector('label');
          if (!input) return;

          const enabled = allowed(input.value);
          input.disabled = !enabled;
          input.classList.toggle('disabled', !enabled);
          if (label) label.classList.toggle('disabled', !enabled);
        });
      }

      function refresh() {
        const selectedTop = top.querySelector('input:checked');
        if (!selectedTop) return;

        updateGroup(top, value =>
          available.some(variant => variant[top.dataset.index] === value)
        );

        updateGroup(bottom, value =>
          available.some(variant =>
            variant[top.dataset.index] === selectedTop.value &&
            variant[bottom.dataset.index] === value
          )
        );
      }

      section.addEventListener('change', event => {
        if (top.contains(event.target) || bottom.contains(event.target)) {
          // Run after the theme's own availability updates.
          queueMicrotask(refresh);
        }
      });

      refresh();
    });
  }

  function start() {
    initializeSetPickers(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();

